import { render, staticRenderFns } from "./InternsPageTableItem.vue?vue&type=template&id=9ee244dc&"
import script from "./InternsPageTableItem.vue?vue&type=script&lang=js&"
export * from "./InternsPageTableItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports